import bkLoadBackendData from '../../../modules/bk/bk-load-backend-data';
import pageHeaderInit from './page-components/page-header/page-header-init';
import PageFooter from './page-components/page-footer/page-footer';
import { i18nInitialized } from 'Base/modules/bk/component-property-providers/bk-translations';
import BkButtonPrimary from './form-elements/bk-button-primary/bk-button-primary';
import BkButtonSecondary from 'Base/shared/bk/components/form-elements/bk-button-secondary/bk-button-secondary';
import BkModal from './page-components/bk-modal/bk-modal';
import BkModalDataPin from './page-components/bk-modal-data-pin';
import amAllocationRoleListInit from './../../../custom-elements/am/am-features/am-allocation-role-list';

const pageComponents = () => {
    const ttlCache = 0;
    bkLoadBackendData.getAccount(ttlCache).then((accountData) => {
        pageHeaderInit(accountData);
    });
    customElements.define('page-footer', PageFooter);
    customElements.define('bk-modal', BkModal);
    customElements.define('bk-button-primary', BkButtonPrimary);
    customElements.define('bk-button-secondary', BkButtonSecondary);
    customElements.define('bk-modal-data-pin', BkModalDataPin);
    amAllocationRoleListInit();
};

i18nInitialized(pageComponents);
